//product page empty div and divider hide

document.addEventListener('DOMContentLoaded', function () {
  const colorBlock = document.querySelector('.color_metafield_cstm');

  if (!colorBlock) return;

  const isEmpty = colorBlock.innerHTML.trim() === '';

  if (isEmpty) {
    colorBlock.style.display = 'none';
    colorBlock.style.margin = '0';
    colorBlock.style.padding = '0';

    const prevDivider = colorBlock.previousElementSibling;
    if (prevDivider && prevDivider.classList.contains('divider')) {
      prevDivider.style.display = 'none';
    }

    const nextDivider = colorBlock.nextElementSibling;
    if (nextDivider && nextDivider.classList.contains('divider')) {
      nextDivider.style.display = 'none';
    }
  }
});

// zoom animation on scroll 

class AnimatedHeroImage {
  constructor(img, container) {
    this.img = img;
    this.container = container;
    this.startScale = 1;  
    this.endScale = 1.0936; 

    this.onScroll = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll);
    this.onScroll();
  }

  onScroll() {
    const containerTop = this.container.getBoundingClientRect().top;

    if (containerTop <= 0) {
      this.img.style.transform = `scale(${this.startScale})`;
    } else {
      this.img.style.transform = `scale(${this.endScale})`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.zoom-section');
  containers.forEach(container => {
    const images = container.querySelectorAll('.zoom-img');
    images.forEach(img => {
      new AnimatedHeroImage(img, container);
    });
  });
});


window.addEventListener('load', function() {
  const hash = window.location.hash.substring(1);
  if (!hash) return;

  const target = document.getElementById(hash);
  if (!target) return;

  setTimeout(function() {
    const topPosition = target.getBoundingClientRect().top + window.scrollY - 150;
    window.scrollTo({
      top: topPosition,
      behavior: 'smooth'
    });
  }, 100);
});

document.querySelectorAll('a[href*="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    const hash = this.getAttribute('href').split('#')[1];
    if (!hash) return;

    const target = document.getElementById(hash);
    if (!target) return;

    e.preventDefault();
    const topPosition = target.getBoundingClientRect().top + window.scrollY - 150;
    window.scrollTo({
      top: topPosition,
      behavior: 'smooth'
    });
  });
});

